/**
 * Claves de sesión para el almacenamiento de la sesión.
 */
export const SESSION_KEYS = {
  DASHBOARD_STATE: 'session:dashboard:state',
  DASHBOARD_STORE: 'session:dashboard:store',
  ORDERS_STATE: 'session:orders:state',
  SEARCHBAR_BACKBUTTON: 'session:searchbar:backbutton',
  LAST_SEARCH_DOC: 'session:last-search:doc'
} as const;
